import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
`;

const ComingSoon: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageWrapper>
      <Result
        status="info"
        title="功能开发中"
        subTitle="我们正在努力开发这项功能，敬请期待！"
        extra={[
          <Button type="primary" key="back" onClick={() => navigate(-1)}>
            返回上一页
          </Button>,
        ]}
      />
    </PageWrapper>
  );
};

export default ComingSoon; 